import { render } from "./listNoEdit.vue?vue&type=template&id=307a8a42&scoped=true"
import script from "./listNoEdit.vue?vue&type=script&lang=js"
export * from "./listNoEdit.vue?vue&type=script&lang=js"

import "./listNoEdit.vue?vue&type=style&index=0&id=307a8a42&scoped=true&lang=css"

import exportComponent from "E:\\Proyectos\\Front_IOSEP\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-307a8a42"]])

export default __exports__